<div [routerLink]="['/']" class="logo-header-wrap"  [ngClass]="themeClass('logo-section1')" >
    <!-- Desktop logo -->
    <img class="img-fluid d-none d-lg-block desktop-img"
        [src]="cdnImagePath + headerdata?.websiteHeader[firstObj + 2]?.desktop_logo" [alt]="domainName"
        [title]="domainName" (error)="onImageError($event)" width="200" height="100" decoding="async"
        fetchpriority="high">
    <!-- Tablet logo -->
    <img [src]="cdnImagePath + headerdata?.websiteHeader[firstObj + 2]?.desktop_logo" [alt]="domainName"
        [title]="domainName" class="img-fluid d-none d-md-block d-lg-none logo-tab mx-auto d-block mt-2" 
        (error)="onImageError($event)" width="248" height="124" loading="eager" fetchpriority="high" decoding="async" />
</div>